import React from 'react'
import { TextField, Button, Grid } from '@material-ui/core'

const Form = (props) => {

  const { day, onInputChange, onSubmitEntry, onCancel } = props;

  return (

      <form style={{marginTop: '8px'}} onSubmit={onSubmitEntry}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              id='classRoom'
              label='Classroom'
              value={day.classRoom}
              onChange={onInputChange('classRoom')}
              fullWidth
            />
          </Grid>        <Grid item xs={6}>
            <TextField
              id='date'
              label='Date'
              type='date'
              value={day.date}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={onInputChange('date')}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id='startTime'
              label='Start time'
              type='time'
              value={day.startTime}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={onInputChange('startTime')}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id='endTime'
              label='End time'
              type='time'
              value={day.endTime}
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              onChange={onInputChange('endTime')}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id='entry'
              label='Entry'
              value={day.entry}
              onChange={onInputChange('entry')}
              fullWidth
            />
          </Grid>
          <Button type='submit'>Save</Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Grid>

      </form>

  )
}

export default Form
